import { IconClose01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import * as S from './style';

interface IProps {
  onClick?: () => void;
}

const ModalCloseBtn = ({ onClick }: IProps) => (
  <S.ModalCloseBtn
    className="modal-close-btn"
    label="닫기"
    icon={<IconClose01 />}
    onClick={onClick}
  />
);

export default ModalCloseBtn;
